/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Timeline_OmittedInputs */



/**
* | output |
* | --- |
* | "{count} further steps were not recorded" |
*
* @param {Chat_Timeline_OmittedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_timeline_omitted = /** @type {((inputs: Chat_Timeline_OmittedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Timeline_OmittedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} weitere Schritte wurden nicht erfasst`)
	return /** @type {LocalizedString} */ (`${i?.count} further steps were not recorded`)
});